/**
 * Facebook SDK (App Events only) for iOS/Android – used for Facebook Ads attribution.
 * Only runs on native (Capacitor iOS/Android). On web we skip init to avoid loading
 * connect.facebook.net/sdk.js, which can throw "Requiring module with unresolved dependencies" in some browsers.
 */

const FACEBOOK_APP_ID = "773634262000066";

let initialized = false;

function isNativeCapacitor() {
  if (typeof window === "undefined" || !window.Capacitor) return false;
  const p = window.Capacitor.getPlatform();
  return p === "ios" || p === "android";
}

export async function initFacebookSdk() {
  if (typeof window === "undefined") return;
  if (initialized) return;
  if (!FACEBOOK_APP_ID) return;
  if (!isNativeCapacitor()) {
    return;
  }
  try {
    const { FacebookLogin } = await import(
      "@capacitor-community/facebook-login"
    );
    await FacebookLogin.initialize({
      appId: FACEBOOK_APP_ID,
      autoLogAppEvents: true,
    });
    await FacebookLogin.setAdvertiserTrackingEnabled({ enabled: true });
    initialized = true;
  } catch (e) {
    // Plugin not available or init failed
  }
}

/**
 * Call after your App Tracking Transparency (ATT) dialog if user denies tracking.
 * @param {boolean} enabled - Pass false when user taps "Ask App Not to Track".
 */
export async function setFacebookAdvertiserTracking(enabled) {
  if (!initialized) return;
  try {
    const { FacebookLogin } = await import(
      "@capacitor-community/facebook-login"
    );
    await FacebookLogin.setAdvertiserTrackingEnabled({ enabled });
  } catch (e) {
    // ignore
  }
}

/**
 * Log a Facebook App Event (for Ads conversion/attribution).
 * @param {string} eventName - e.g. 'fb_mobile_activate_app', 'fb_mobile_complete_registration', 'fb_mobile_purchase'
 * @see https://developers.facebook.com/docs/app-events
 */
export async function logFacebookEvent(eventName) {
  if (!initialized) await initFacebookSdk();
  if (!initialized) return;
  try {
    const { FacebookLogin } = await import(
      "@capacitor-community/facebook-login"
    );
    await FacebookLogin.logEvent({ eventName });
  } catch (e) {
    // ignore
  }
}
